import { apiService } from '.';
import { Attachment } from '../shared/types/shared';

export type EmailSendingPayload = {
    account: string;
    caseId: string;
    recipients: string[];
    subject: string;
    body: string;
    attachments?: Attachment[];
};

export type EmailSendingRecord = {
    id: string;
    caseId: string;
    recipient: string;
    subject: string;
    body: string;
    attachments?: string[] | null;
    response?:
        | {
              statusCode?: number;
              deliveryId?: string;
              message?: string;
          }
        | null;
    createdBy?: { name?: string; surname?: string; username?: string };
    created_at: Date;
};

export async function asyncGetEmailSendingByAccount(
    idAccount: string,
    page?: number,
    pageSize?: number
): Promise<{ data: EmailSendingRecord[]; total: number }> {
    try {
        const {
            items: data,
        }: {
            items: { data: EmailSendingRecord[]; total: number };
        } = await apiService.get(`/api/email-sending/account/${idAccount}`, {
            limit: pageSize || 10,
            offset: (page || 0) * (pageSize || 10),
        });

        return data;
    } catch (error) {
        return { data: [], total: 0 };
    }
}

export async function asyncSendEmailSending(
    payload: EmailSendingPayload
): Promise<any | undefined> {
    try {
        const { items: data }: { items: any } = await apiService.post(
            '/api/email-sending',
            payload
        );

        return data;
    } catch (error) {
        return undefined;
    }
}